import { bool } from "prop-types";
import styled from "styled-components";
import { PageWrapper } from "../../../styles/page";

export const ManagementPageWrapper = styled(PageWrapper)`
  flex-direction: row;
`;

export const ManagementContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 86px;
`;

export const ManagementEditWrapper = styled.div`
  min-width: 929px;
  width: 61%;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;
export const ManagementEditPoster = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  > .title {
    color: #1a191a;
    font-family: Pretendard;
    font-size: 16.861px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
export const EditPosterImageBox = styled.div<{ image: string }>`
  width: 115.614px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%),
    url(${({ image }) => image}) lightgray 50% / cover no-repeat;
  border-radius: 15px;
`;
export const ManagementOtherSetting = styled.div<{ isRed?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 20px;

  > .button {
    cursor: pointer;
    border-radius: 8px;
    border: 0.674px solid var(--Black-200, #b7b7b7);
    background: ${(p) => (p.isRed ? "#FF0000" : "#7f25fb")};
    color: #fff;
    padding: 15px 24px;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

export const PosterImageWrapper = styled.div`
  width: 100%;
  padding-bottom: 50px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  > .input-box {
    cursor: pointer;
  }

  .swiper {
    flex: 1;
    height: 150px;
  }

  .swiper-slide {
    width: 115.614px;
    height: 150px;
  }
`;
export const ManagementEditBox = styled.div`
  padding: 30px 50px 50px 20px;
  border-radius: 6.744px;
  background: #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const ManagementEditRow = styled.div<{ addMargin?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  ${({ addMargin }) => addMargin && "margin-top: 15px;"}
`;

export const ManagementEditItem = styled.div<{
  isAlignCenter: boolean;
  flex?: number;
}>`
  flex: ${(p) => (p.flex ? p.flex : 1)};
  max-width: 100%;
  display: flex;
  flex-direction: row;
  gap: 50px;

  .swiper {
    flex: 1;
    height: 100px;
  }

  .swiper-slide {
    width: 100px;
    height: 100px;
  }

  > .select-image {
    margin-right: -25px;
  }

  ${({ isAlignCenter }) => isAlignCenter && "align-items: center;"}
  > .title {
    width: 100px;
    color: #1a191a;
    font-family: Pretendard;
    font-size: 16.861px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const EditImageBox = styled.div<{ image: string }>`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%),
    url(${({ image }) => image}) lightgray 50% / cover no-repeat;
  border-radius: 15px;
`;

export const EditFacilitiesWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 21px;
`;

export const EditFacilitiesItem = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  width: 75px;
  height: 75px;
  border-radius: 5px;
  border: 1px solid var(--Black-200, #b7b7b7);
  background: ${({ active }) => (active ? "#7F25FB" : "#FFF")};
  > img {
    ${({ active }) =>
      !active && "filter: grayscale(100%) brightness(80%) contrast(50%);"}
  }
  > .title {
    color: ${({ active }) => (active ? "#fff" : "#B7B7B7")};
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const EditInputBox = styled.div<{ active: boolean }>`
  flex: 1;
  padding: 5.396px 8.093px;
  border-radius: 2.698px;
  border: 0.674px solid var(--Black-200, #b7b7b7);
  background: #fff;
  background: ${({ active }) =>
    !active ? "var(--Black-100, #f0f0f0)" : "#fff"};

  > textarea {
    height: 200px;
    width: 100%;
    border: none;
    outline: none;
    color: #121212;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    background: none;
    resize: none;
  }

  > textarea::placeholder {
    color: #808080;
  }

  > input {
    height: 21px;
    width: 100%;
    border: none;
    outline: none;
    color: ${({ active }) => (!active ? "#808080" : "#121212")};
    font-family: Pretendard;
    font-size: 10px;
    font-weight: 500;
    line-height: normal;
    background: none;
    padding: 0px;
  }

  > input::placeholder {
    font-size: 11px;
  }
`;

export const ManagementRightWrapper = styled.div`
  padding: 50px 0 0 80px;

  > img {
    position: absolute;
    z-index: 50;
    pointer-events: none;
  }

  > .phone-wrapper {
    width: 470px;
    height: 973.09px;
    position: relative;
    overflow-y: auto;
    scrollbar-width: none;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const EventBoxWrapper = styled.div`
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    padding-left: 20px;
  }

  .swiper {
    width: 100%;
    height: 368px;
  }
`;

export const EventImageWrapper = styled.div`
  height: 368px;
  border-radius: 8px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
`;

export const ManageMentPreviewInfo = styled.div`
  width: 100%;
  padding: 0 32px;
  box-sizing: border-box;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    margin-bottom: 12px;
  }

  > .box {
    padding: 16px;
    background: var(--Black-100, #f0f0f0);
    border-radius: 8px;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 400;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
`;

export const PreviewFacilitiesWrapper = styled.div`
  width: 100%;
  padding: 10px 52px 70px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 26px;

  > .item {
    display: flex;
    flex-direction: column;
    width: 72px;
    height: 55px;
    align-items: center;
    justify-content: space-between;
  }

  > .title {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    color: #444;
  }
`;
